import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Button, ErrorNote, Field } from '../components/ui'
import { staffApi } from './api'

export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const navigate = useNavigate()
  const [search] = useSearchParams()
  const queryClient = useQueryClient()
  const login = useMutation({
    mutationFn: () => staffApi.login(email, password),
    onSuccess: (user) => {
      queryClient.setQueryData(['me'], user)
      const next = search.get('next')
      navigate(next && next.startsWith('/') && !next.startsWith('//') ? next : '/requests', { replace: true })
    },
  })

  return (
    <div className="flex min-h-dvh items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center text-center">
          <img src="/favicon.svg" alt="" className="mb-4 size-11" />
          <h1 className="text-xl font-semibold text-ink-950">Website Reviewr</h1>
          <p className="mt-1 text-sm text-ink-500">Sign in to the Computer CoPilot team dashboard</p>
        </div>
        <form
          className="card space-y-4 p-6"
          onSubmit={(event) => {
            event.preventDefault()
            login.mutate()
          }}
        >
          <Field label="Email" htmlFor="email">
            <input
              id="email"
              type="email"
              className="field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
              autoFocus
            />
          </Field>
          <Field label="Password" htmlFor="password">
            <input
              id="password"
              type="password"
              className="field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </Field>
          <ErrorNote>{login.error?.message}</ErrorNote>
          <Button type="submit" variant="primary" size="lg" className="w-full" loading={login.isPending}>
            Sign in
          </Button>
        </form>
        <p className="mt-6 text-center text-xs text-ink-500">
          Clients don’t need an account — share a project’s review link with them.
        </p>
      </div>
    </div>
  )
}
